(ns manatee.spec.core
  (:require [clojure.spec.alpha :as s]
            [clojure.string :as string]))

;; Due to an outstanding issue in spec, some of the following specs
;; are in the form of (s/and <blah>) instead of <blah> directly.
(comment
  (s/def ::spec1 ::not-empty)
  (-> (s/explain-data ::spec1 "") ::s/problems first :via)
  ;; prints [:user/spec1]
  ;; which does not mention ::not-empty
  (s/def ::spec2 (s/and ::not-empty))
  (-> (s/explain-data ::spec2 "") ::s/problems first :via)
  ;; prints [:user/spec2 :user/not-empty]
  ;; Now we have the proper path
  )
;; When this gets fixed, we can simplify here.

(defn aggregate-config-values
  [queue-config]
  (->> (vals queue-config)
       (map #(apply + (vals %)))))

(s/def ::not-empty #(seq %))
(s/def ::user-email (s/and ::not-empty))
(s/def ::user-role #{"annotator" "admin" "project-owner" "senior-annotator"})
(s/def ::queue-name (s/and ::not-empty))
(s/def ::task-config (s/and ::not-empty))
(s/def ::queue-users (s/and ::not-empty))

(s/def ::queue-form
  (s/keys
   :req-un [::queue-name
            ::task-config-id]
   :opt-un [::is-archived?
            ::queue-users]))

(s/def ::some* some?)
(s/def ::some? (s/and ::some*))
(s/def ::non-blank-string (s/and string? (complement string/blank?)))
(s/def ::has-content (s/and string? #(-> % (string/trim) (count) (> 1))))
(def score-range-int-message "Must be a number between -100 and 100")
(s/def ::score-range-int (s/and number? #(<= -100 % 100)))
(s/def ::score integer?)
(s/def ::optional-score (s/nilable integer?))
(s/def ::labelled-score string?)
(s/def ::answer-score some?)
(s/def ::pos-number (s/or :pos-int? pos-int?
                          :pos-double? (s/and double? pos?)))

(s/def ::part
  (s/keys
   :req-un [::number]
   :opt-un [::rubric ::short-rubric]))

(s/def ::question
  (s/keys
   :req-un [::text
            ::part]))

(s/def ::item
  (s/keys
   :req-un [::question]
   :opt-un [::source-url]))

(s/def ::answer-waveplayer
  (s/cat
   :props (s/keys
           :req-un [::item])))

(s/def ::question-content
  (s/cat
   :props (s/keys
           :req-un [::item])))

(s/def ::id uuid?)
(s/def ::type #{:answer :part})
(s/def ::medium #{:speech :text})
(s/def ::label string?)
(s/def ::archived? boolean?)

(s/def ::rejection-option
  (s/keys :req-un [::id
                   ::type
                   ::medium
                   ::label
                   ::archived?]))
